"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Loading_styles_1 = __importDefault(require("./Loading.styles"));
var Loading = function () { return (react_1.default.createElement(Loading_styles_1.default, null,
    react_1.default.createElement("div", { className: "container" },
        react_1.default.createElement("div", { className: "row" },
            react_1.default.createElement("svg", { className: "spinner", viewBox: "0 0 50 50" },
                react_1.default.createElement("circle", { className: "path", cx: "25", cy: "25", r: "20", fill: "none", strokeWidth: "5" })))))); };
exports.default = Loading;
